var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIconGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66634 7.33594C2.66634 4.75861 4.75568 2.66927 7.33301 2.66927C9.91034 2.66927 11.9997 4.75861 11.9997 7.33594C11.9997 8.59329 11.5024 9.7345 10.6938 10.5736C10.6711 10.5912 10.6491 10.6104 10.6283 10.6312C10.6074 10.6521 10.5882 10.674 10.5707 10.6968C9.73157 11.5053 8.59036 12.0026 7.33301 12.0026C4.75568 12.0026 2.66634 9.91327 2.66634 7.33594ZM11.0781 12.0239C10.0517 12.845 8.74968 13.3359 7.33301 13.3359C4.0193 13.3359 1.33301 10.6496 1.33301 7.33594C1.33301 4.02223 4.0193 1.33594 7.33301 1.33594C10.6467 1.33594 13.333 4.02223 13.333 7.33594C13.333 8.75261 12.842 10.0546 12.0209 11.0811L14.4711 13.5312C14.7314 13.7916 14.7314 14.2137 14.4711 14.474C14.2107 14.7344 13.7886 14.7344 13.5283 14.474L11.0781 12.0239Z",
    fill: "#017C57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconGreen);
export default __webpack_public_path__ + "static/media/searchIconGreen.8d43c03d1a4d54c2d7015fce5b52895f.svg";
export { ForwardRef as ReactComponent };